import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
const TYPE = 'graph.Threshold';
function create(opts) {
  const options = opts || {};
  return {
    type: TYPE,
    id: v4(),
    color: options.color || 'var(--color-danger500, #ff0000)',
    value: options.value || null,
    // { type : 'value.Thresholdizer', value : 20 },
    opacity: options.opacity || 1,
    width: options.width || 1
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('color'),
  ...ModelUtil.createAllValue('value'),
  ...ModelUtil.createAllValue('opacity'),
  ...ModelUtil.createAllValue('width')
};